import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Contact.css';
import { appCheck } from '../firebase';
import '../pages/Services/Services.css';


const Contact = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      const messageArea = form.current.message;
      messageArea.value = location.state.message;
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Get App Check token which uses reCAPTCHA v3
      const appCheckTokenResponse = await appCheck.getToken();

      const response = await fetch('https://api.sradhatech.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Firebase-AppCheck': appCheckTokenResponse.token,
          'Authorization': 'Bearer ' + appCheckTokenResponse.token
        },
        body: JSON.stringify({
          name: e.target.name.value,
          email: e.target.email.value,
          phone: e.target.phone.value,
          message: e.target.message.value,
          consent_sms: e.target.consent_sms.checked
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus('Thank you for contacting Sradha Tech, our team will get in touch with you shortly.');
        e.target.reset();
      } else {
        throw new Error(data.error || 'Failed to send message');
      }
    } catch (error) {
      setSubmitStatus(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="service-header">
        <h1>Let&apos;s Connect</h1>
        <p>Start a conversation about your next big idea</p>
      </div>

      <div className="container">
        <div className="contact-container">
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="info-content">
                <h3>Our Location</h3>
                <p>
                  6600 Paige Rd,
                  <br />
                  The Colony, TX , 75056
                  <br />
                  USA
                </p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="info-content">
                <h3>Email Us</h3>
                <p>info@sradhatech.com</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-phone-alt"></i>
              </div>
              <div className="info-content">
                <h3>Call Us</h3>
                <p>
                  <a href="tel:+14692624000" className="contact-link">
                    +1 (945) 249-7292
                  </a>
                </p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="info-content">
                <h3>Business Hours</h3>
                <p>
                  Monday - Friday
                  <br />
                  9:00 AM - 6:00 PM CST
                </p>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <form ref={form} onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9+]/g, ''); }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  required
                />
              </div>

              <div className="form-group checkbox-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label className="checkbox-label" style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '0.85rem', color: '#666' }}>
                  <input
                    type="checkbox"
                    id="consent_sms"
                    name="consent_sms"
                    required
                    style={{ marginTop: '4px', width: 'auto', accentColor: 'var(--primary-color)' }}
                  />
                  <span style={{ flex: 1 }}>
                    By providing your phone number, you agree to receive a text message from Sradha Tech. Message and Data rates may apply. Message frequency varies. To stop receiving messages, reply STOP at any time. For more information, reply HELP. <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>Privacy Policy</a> &amp; <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>Terms and Conditions</a>.
                  </span>
                </label>

                <label className="checkbox-label" style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '0.85rem', color: '#666' }}>
                  <input
                    type="checkbox"
                    id="consent_terms"
                    name="consent_terms"
                    required
                    style={{ marginTop: '4px', width: 'auto', accentColor: 'var(--primary-color)' }}
                  />
                  <span style={{ flex: 1 }}>
                    I agree to the <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>Terms and Conditions</a> and <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>Privacy Policy</a>.
                  </span>
                </label>
              </div>

              {submitStatus && (
                <div className={`submit-status ${submitStatus.includes('success') ? 'success' : 'error'}`}>
                  {submitStatus}
                </div>
              )}

              <button
                type="submit"
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
